import { writable } from "svelte/store";

export const referenceDataKeyworkerList = writable([]);
export const referenceDataStatusList = writable([]);
export const referenceDataEthnicityList = writable([]);
export const referenceDataNationalityList = writable([]);
export const referenceDataReligionList = writable([]);
export const referenceDataUnitList = writable([]);
export const referenceDataWingList = writable([]);
export const referenceDataCellStatusList = writable([]);
export const referenceDataRegimeLevelList = writable([]);
export const referenceDataAgeRangeList = writable([]);

export let referenceDataSiteList = [];
export let referenceDataSurveyAnswerLookupList = [];
export let referenceDataSurveyQuestionConfiguration = [];

export let referenceDataEarlyRiskTabList = [];
export let referenceDataRiskFactorTabList = [];

export const setReferenceDataCohort = (data) => {
    referenceDataEthnicityList.set(data.ethnicityList);
    referenceDataNationalityList.set(data.nationalityList);
    referenceDataReligionList.set(data.religionList);
    referenceDataStatusList.set(data.statusList);
    referenceDataUnitList.set(data.unitList);
    referenceDataWingList.set(data.wingList);
    referenceDataCellStatusList.set(data.vptCellStatusList);
    referenceDataRegimeLevelList.set(data.regimeLevelList);
    referenceDataAgeRangeList.set(data.ageRangeList);

    referenceDataSiteList = data.prisonConfigList;
}

export const setReferenceDataSurveyAnswerLookupList = (data) => {
    referenceDataSurveyAnswerLookupList = data;
}

export const setReferenceDataSurveyQuestionConfiguration = (data) => {
    referenceDataSurveyQuestionConfiguration = data;
}

export const setReferenceDataEarlyRiskTabList = (data) => {
    referenceDataEarlyRiskTabList = data;
}

export const setReferenceDataRiskFactorTabList = (data) => {
    referenceDataRiskFactorTabList = data;
}

export var getReferenceDataSiteName = (siteUrn) => {
    if (siteUrn && siteUrn > 0) {
        let foundItem = referenceDataSiteList.find(site => site.siteUrn === siteUrn);
        if (foundItem != null) {
            return foundItem.prisonTitle;
        } else {
            return "[Site not found]";
        }
    }
    else {
        return "";
    }
}

function convertIntToRGBColor(number) {
    number >>>= 0;
    var b = number & 0xFF,
        g = (number & 0xFF00) >>> 8,
        r = (number & 0xFF0000) >>> 16;
    return "rgb(" + [r, g, b].join(",") + ")";
}

export var getReferenceDataSurveyAnswerGroupingColour = (surveyUrn, grouping) => {
    if (surveyUrn && surveyUrn != null && grouping && grouping != null) {
        let foundItem = referenceDataSurveyAnswerLookupList.find(surveyAnswer => surveyAnswer.surveyUrn === surveyUrn && surveyAnswer.grouping === grouping);
        if (foundItem != null) {
            return convertIntToRGBColor(foundItem.colour);
        }
        else {   //return black by default
            return 0;
        }
    }
    else {
        return "";
    }
}

export var getReferenceDataSurveyAnswerGroupingDescription = (surveyUrn, grouping, shortText) => {
    if (surveyUrn && surveyUrn != null && grouping && grouping != null) {
        let foundItem = referenceDataSurveyAnswerLookupList.find(surveyAnswer => surveyAnswer.surveyUrn === surveyUrn && surveyAnswer.grouping === grouping);
        if (foundItem != null) {
            if (shortText) {
                return foundItem.groupingDescription.replace(" Answer","");   //remove Answer from end if exists
            }
            else {
                return foundItem.groupingDescription;
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
}

export var getReferenceDataSurveyAnswerColour = (surveyUrn, questionNumber, choiceUrn) => {
    if (surveyUrn && surveyUrn != null && questionNumber && questionNumber != null && choiceUrn && choiceUrn != null) {
        let foundItem = referenceDataSurveyAnswerLookupList.find(surveyAnswer => surveyAnswer.surveyUrn === surveyUrn && surveyAnswer.questionNumber === questionNumber && surveyAnswer.choiceUrn === choiceUrn);
        if (foundItem != null) {
            return convertIntToRGBColor(foundItem.colour);
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
}

export var getReferenceDataSurveyAnswerDescription = (surveyUrn, questionNumber, choiceUrn) => {
    if (surveyUrn && surveyUrn != null && questionNumber && questionNumber != null && choiceUrn && choiceUrn != null) {
        let foundItem = referenceDataSurveyAnswerLookupList.find(surveyAnswer => surveyAnswer.surveyUrn === surveyUrn && surveyAnswer.questionNumber === questionNumber && surveyAnswer.choiceUrn === choiceUrn);
        if (foundItem != null) {
            return foundItem.choiceDescription;
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
}

export var getReferenceDataSurveyQuestionDescription = (surveyUrn, questionNumber, shortDescription) => {
    if (surveyUrn && surveyUrn != null && questionNumber && questionNumber != null) {
        let foundItem = referenceDataSurveyQuestionConfiguration.find(surveyQuestion => surveyQuestion.surveyUrn === surveyUrn && surveyQuestion.questionNumber === questionNumber);
        if (foundItem != null) {
            if (shortDescription && shortDescription === true) {
                return foundItem.title;
            } else {
                return foundItem.question;
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
}

export var getReferenceDataItemFromList = (id, list, descProperty, filterProperty) => {
    if (id) {
        let foundItem = list.find(item => item[filterProperty] === id);
        if (foundItem != null) {
            return foundItem[descProperty];
        } else {
            return "";
        }
    } else {
        return "";
    }
}

export const applyFilters = (codeString, list, idProperty) => {
    let codes = codeString.split(',');
    let refreshedList = list.map(e => {
        if (codes.includes(e[idProperty].toString())) {
            return {...e, checked: true};
        } else {
            return e;
        }
    });
    return refreshedList;
}